import React from 'react';
import { FullContainer, ProgressContainer } from './ProgressBar.styled';

interface ProgressBarProps {
  progress: number;
  containerColor?: string;
  progressColor?: string;
  height?: number;
  disabled?: boolean;
}

const ProgressBar = (props: ProgressBarProps) => {
  const { disabled = false} = props;
  return (
    <FullContainer height={props.height} disabled={disabled} color={props.containerColor}>
        <ProgressContainer width={isNaN(props.progress) ? 0 : props.progress} id="progress-container" color={props.progressColor} height={props.height} disabled={disabled}/>
    </FullContainer>
  );
};

export default ProgressBar;